import React from 'react';

type ArchiveProps = {
  title?: string;
};

const Archive = ({ title = undefined }: ArchiveProps): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {title && <title data-testid="icon-archive">{title}</title>}
    <path d="M4.7439 7.88281V19.0005H19.2561V7.88281" stroke="#A6A6A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.1342 11.2227H13.8658" stroke="#A6A6A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.5 5H20.5V7.88244H3.5V5Z" stroke="#A6A6A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Archive;
